import {
  RenterAccessmentBadge,
  RenterAssessmentParams,
  RenterAssessmentItem,
} from '../../interfaces/renter-profile-assessment.interface';

export const creditScoreAssessmentBadges: {
  pass: RenterAccessmentBadge;
  low: RenterAccessmentBadge;
  noHistory: RenterAccessmentBadge;
} = {
  pass: { title: 'Meets credit requirement', badgeColor: 'green' },
  low: { title: 'Below credit requirement', badgeColor: 'red' },
  noHistory: { title: 'No credit history', badgeColor: 'red' },
};

export function getCreditScoreAssessment(assessmentParams: RenterAssessmentParams): RenterAssessmentItem {
  const uiRepresentation = assessmentParams.screening?.creditScore || assessmentParams.renter?.creditScore || 'N/A';
  const minCreditRequirement = assessmentParams.property?.renterRequirements?.minimumCreditScore;
  const lowerUi = uiRepresentation.toLowerCase();
  let badge: RenterAccessmentBadge | null = null;

  if (lowerUi.includes('no credit history')) {
    badge = creditScoreAssessmentBadges.noHistory;
  } else {
    const parsed = parseCreditScore(uiRepresentation);
    if (minCreditRequirement && parsed) {
      if (parsed.length === 1 && parsed[0] >= minCreditRequirement) {
        badge = creditScoreAssessmentBadges.pass;
      } else if (parsed.length === 2) {
        if (parsed[0] >= minCreditRequirement) {
          badge = creditScoreAssessmentBadges.pass;
        } else if (parsed[1] <= minCreditRequirement) {
          badge = creditScoreAssessmentBadges.low;
        }
      } else if (parsed[0] < minCreditRequirement) {
        badge = creditScoreAssessmentBadges.low;
      }
    }
  }

  return {
    uiRepresentation,
    badge,
  };
}

function parseCreditScore(score: string | null | undefined): number[] | null {
  if (!score) return null;

  const trimmedScore = score.trim();

  // Single number
  if (/^\d{3}$/.test(trimmedScore)) return [parseInt(trimmedScore, 10)];

  // Interval: "600-660"
  const interval = trimmedScore.match(/^(\d{3})\s*[-–]\s*(\d{3})$/);
  if (interval) return [parseInt(interval[1], 10), parseInt(interval[2], 10)];

  // "600+" or "Above 600"
  const above = trimmedScore.match(/^(?:Above\s*)?(\d{3})\+?$/i);
  if (above) return [parseInt(above[1], 10), 850];

  // "Below 600"
  const below = trimmedScore.match(/^Below\s*(\d{3})$/i);
  if (below) return [300, parseInt(below[1], 10)];

  // "Around 560"
  const around = trimmedScore.match(/^Around\s*(\d{3})$/i);
  if (around) {
    const val = parseInt(around[1], 10);
    return [val - 20, val + 20];
  }

  return null;
}
